"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const client_1 = require("react-dom/client");
const YogaApp_1 = require("./YogaApp");
const main = document.getElementById('main');
if (main === null)
    throw new Error("Uh oh! HTML is missing 'main' element");
const root = (0, client_1.createRoot)(main);
root.render(react_1.default.createElement(YogaApp_1.YogaApp, null));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvaW5kZXgudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7O0FBQUEsa0RBQTBCO0FBQzFCLDZDQUFvRDtBQUNwRCx1Q0FBb0M7QUFFcEMsTUFBTSxJQUFJLEdBQXFCLFFBQVEsQ0FBQyxjQUFjLENBQUMsTUFBTSxDQUFDLENBQUM7QUFDL0QsSUFBSSxJQUFJLEtBQUssSUFBSTtJQUNmLE1BQU0sSUFBSSxLQUFLLENBQUMsdUNBQXVDLENBQUMsQ0FBQztBQUUzRCxNQUFNLElBQUksR0FBUyxJQUFBLG1CQUFVLEVBQUMsSUFBSSxDQUFDLENBQUM7QUFDcEMsSUFBSSxDQUFDLE1BQU0sQ0FBQyw4QkFBQyxpQkFBTyxPQUFFLENBQUMsQ0FBQyJ9